/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatiPianificazioneResDto } from '../../models/stati-pianificazione-res-dto';

export interface StatiPianificazioniControllerFindManystatiPianificazioni$Params {}

export function statiPianificazioniControllerFindManystatiPianificazioni(
  http: HttpClient,
  rootUrl: string,
  params?: StatiPianificazioniControllerFindManystatiPianificazioni$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<StatiPianificazioneResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    statiPianificazioniControllerFindManystatiPianificazioni.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StatiPianificazioneResDto>>;
      }),
    );
}

statiPianificazioniControllerFindManystatiPianificazioni.PATH =
  '/statiPianificazione';
